import { keyframes } from '@emotion/react';

export const scAnimSigninWave = keyframes`
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -1442px;
  }
`;

export const scAnimSigninWaveSwell = keyframes`
  0%, 100% {
    transform: translate3d(0, -25px, 0);
  }
  50% {
    transform: translate3d(0, 5px, 0);
  }
`;

export const scAnimFadeLeft = (distance: number) => keyframes`
  0% {
    opacity: 0;
    transform: translateX(${distance}px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const scAnimFadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const scAnimBufferingIndcSpinner = keyframes`
  from {
    transform: rotate(0deg);
  }
  
  to {
    transform: rotate(359deg);
  }
`;

export const scAnimPlayerInteractionFeedbackCircle = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.7);
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: scale(1.3);
  }
`;
